// src/components/ui/calendar/week/WeekViewTimeSlot/WeekViewTimeSlot.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const WeekViewTimeSlot = ({
  date,
  hour,
  dayIndex,
  events = [],
  backgroundEvents = [],
  isClickable = false,
  onClick,
  children,
  // Availability props
  hasAvailability = false,
  viewingPartnerAvailability = false,
  // Block mode props
  isBlockMode = false,
  isSelected = false,
  isDragHighlighted = false,
  onMouseDown,
  onMouseEnter,
  className = ''
}) => {
  const handleClick = () => {
    if (isBlockMode) return; // Block mode uses mousedown/mouseup
    if (isClickable && onClick) {
      onClick(date, hour);
    }
  };

  return (
    <div
      className={cn(
        // Base time slot styling
        "relative border-r border-slate-600/30 last:border-r-0 h-16 group",
        "transition-colors duration-200",

        // Normal mode cursor
        !isBlockMode && isClickable && "cursor-pointer",

        // Block mode: selected slot
        isSelected && "bg-blue-500/30 border border-blue-400",

        // Block mode: drag preview highlight
        isDragHighlighted && !isSelected && "bg-blue-400/20 border border-blue-400/50",

        // Block mode: unselected hover
        isBlockMode && !isSelected && !isDragHighlighted && "cursor-crosshair hover:bg-blue-500/10",

        // Availability styling (only outside block mode)
        !isBlockMode && hasAvailability && "bg-purple-600/10 border-purple-500/20",
        !isBlockMode && hasAvailability && "hover:bg-purple-600/20",

        // Default hover (outside block mode, no availability)
        !isBlockMode && !hasAvailability && "hover:bg-slate-700/10",

        className
      )}
      onClick={handleClick}
      onMouseDown={isBlockMode ? onMouseDown : undefined}
      onMouseEnter={isBlockMode ? onMouseEnter : undefined}
    >
      {/* Partner availability indicator (only outside block mode) */}
      {!isBlockMode && hasAvailability && (
        <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
      )}

      {/* Events content */}
      {children}
    </div>
  );
};

export default WeekViewTimeSlot;